import * as React from 'react'

import asyncAction from 'modules/core/lib/asyncAction'

import RemoveCategoryModal from 'modules/surveys/components/Questions/Categories/RemoveCategoryModal'
import { useQuestionCategory } from 'modules/surveys/hooks/useQuestionCategory'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import questionConfigs from 'modules/surveys/store/collections/questionConfigs'

interface Props {
  formId: number
  onClose: () => void
  questionGroupConfigId: number
  questionCategoryId: number
}

// TODO: review this interface used in `deleteQuestionCategory`
// interface DataObject {
//   id: number;
// }
export default function RemoveCategoryModalContainer({
  formId,
  questionCategoryId,
  onClose,
}: Props) {
  const { questionCategory } = useQuestionCategory(questionCategoryId, formId)
  const { updateCanBeStarted } = useSurveyShowContext()

  const refetchQuestionConfigs = () =>
    questionConfigs.fetch({
      remove: false,
      data: {
        surveys_question_group_config_id:
          questionCategory?.attributes.surveys_question_group_config_id,
        surveys_form_id: formId,
      },
    })

  const deleteQuestionCategory = async () => {
    if (!questionCategory) return

    const { success, value } = await asyncAction(() =>
      questionCategory.destroy({ data: { surveys_form_id: formId } })
    )

    // We reorder all question configs in backend
    if (success) {
      await refetchQuestionConfigs()
      await updateCanBeStarted()
    }

    return value
  }

  if (!questionCategory) return null

  return (
    <RemoveCategoryModal
      category={questionCategory}
      questionsCount={questionCategory.questionConfigs.length}
      onClose={onClose}
      onSubmit={deleteQuestionCategory}
    />
  )
}
